/**
 * Created by ronmarsiano on 06/02/2018.
 * this directive is for the selection of the ike
 * route option and allow to define the specific ranges
 */
mainApp.directive('ikeRoute', function() {
    return {
        templateUrl: '/public/directives/ikeRoute.html',
        scope: {
            ikeRouteConfiguration: '='
        },

        controller:  ['$scope', '$timeout', '$state',"IconsService", function($scope, $timeout, $state, IconsService) {

            $scope.icons = IconsService.getIcons();
            $scope.customIps = [];
            $scope.interfacesShowItem ='plainText';

            $scope.routeMessage = 'Implicit: Creates a single Phase II for all traffic,Explicit: Creates ' +
                'Phase II for all subnets in the current site, Full Mesh: Creates Phase II for all subnets in the account ' +
                'Specific Ranges: Creates Phase II for specifically defined subnets';

            var implicitRouteOption = {
                name: 'Implicit: 0.0.0.0/0<-->0.0.0.0/0 (A single tunnel from all local ranges to all remote ranges)',
                value: 'IMPLICIT'
            };

            var specificRouteOption = {
                name: 'Specific: x.x.x.x/y<-->a.a.a.a/b (A tunnel from each local range to specific remote ranges)',
                value: 'SPECIFIC_RANGES'
            };

            var explicitRouteOption  = {
                name: 'Explicit: x.x.x.x/y<-->0.0.0.0/0 (A tunnel from each local range to all remote ranges)',
                value: 'EXPLICIT'
            };

            $scope.routeOption = [
                implicitRouteOption,
                specificRouteOption,
                explicitRouteOption
            ];

            function allOptions() {
                var options = [];
                options.push(implicitRouteOption, specificRouteOption, explicitRouteOption);
                return options;
            }

            /**
             * open the network range dialog, the dialog is
             * relevant for the specific ranges
             */
            $scope.openAddNetworkRangeDlg = function(){
                $scope.interfacesShowItem ='custom';
                $scope.$root.openPopup('ikeRouteAddRangeDialog');

            };


            function init() {
                if($scope.ikeRouteConfiguration){
                    $scope.ikeRouteConfiguration.reload = function () {
                        if($scope.ikeRouteConfiguration.ikeConfiguration && $scope.ikeRouteConfiguration.ikeConfiguration.customRanges){
                            $scope.networkRanges=[];
                            var ranges = "";
                            $scope.ikeRouteConfiguration.ikeConfiguration.customRanges.forEach(function(range){
                                $scope.networkRanges.push(range);
                                ranges = ranges + "," + range;
                            });
                            $scope.customIps = ranges.substring(1,ranges.length);
                        }
                        else{
                            $timeout($scope.ikeRouteConfiguration.reload,300)
                        }
                    }
                }
                else{
                    $timeout(init,300);
                }
            }


            /**
             * add network to the custom ranges on the site
             **/
            $scope.addNetworkRange = function(){
                if($scope.ikeRouteConfiguration && $scope.ikeRouteConfiguration.ikeConfiguration && $scope.ikeRouteConfiguration.ikeConfiguration.routeOption){
                    $scope.networkRanges = [];
                    $scope.ikeRouteConfiguration.ikeConfiguration.customRanges = [];
                    if($scope.customIps){
                        var customIpsArr = $scope.customIps.split(",");
                        customIpsArr.forEach(function(customIpStr){
                            // ignore redundant ","
                            if(customIpStr != ""){
                                var customIpTokens = customIpStr.split(":");
                                $scope.networkRanges.push({"id":customIpTokens[1],"display_name":customIpTokens[0] + ":" + customIpTokens[1], "ip":customIpTokens[1]});
                                $scope.ikeRouteConfiguration.ikeConfiguration.customRanges.push(customIpStr);
                            }
                        });
                    }
                    $scope.$root.closePopup('ikeRouteAddRangeDialog');
                }
            };


            /**
             * this callback weill be invoked when user clicks on the X button near a network range
             * cause to delete the network range
             **/
            $scope.onNetworkRangeRemove = function(){
                if($scope.ikeRouteConfiguration && $scope.ikeRouteConfiguration.ikeConfiguration && $scope.ikeRouteConfiguration.ikeConfiguration.routeOption){
                    $scope.customIps ="";
                    $scope.networkRanges.forEach(function(networkRange){
                        if(networkRange.display_name){
                            $scope.customIps = $scope.customIps+","  +networkRange.display_name;
                        }
                        else{
                            $scope.customIps = $scope.customIps+","  +networkRange;
                        }
                    });
                    $scope.customIps= $scope.customIps.substring(1,$scope.customIps.length);
                }
                $scope.addNetworkRange();
            };


            /**
             * closing the plain text popup
             */
            $scope.closeShowInPlainText = function () {
                $scope.rangeText = '';
                $scope.$root.closePopup('showInPlainText');
            };


            /**
             * we want to change all the route options according to the site
             * that we have , if the site has only native range we don't have the
             * option to chose explicit
             *
             * the indication for that is found on the ikeRouteConfiguration
             */
            $scope.$watch("ikeRouteConfiguration.allRouteOptions", function(newVal, oldVal) {
                if(newVal != oldVal) {
                    if($scope.ikeRouteConfiguration.onlySpecific) {
                       onlySpecific();
                       return;
                    }
                    setOptions(newVal);
                }
            });

            function setOptions(allRouteOptions) {
                if (typeof allRouteOptions == 'undefined') {
                    return;
                }
                if(allRouteOptions == true){
                    $scope.routeOption = allOptions();
                }
                else {
                    $scope.routeOption = allOptions();
                    $scope.routeOption.pop();

                    if($scope.ikeRouteConfiguration.ikeConfiguration.routeOption == 'EXPLICIT'){
                        $scope.ikeRouteConfiguration.ikeConfiguration.routeOption = 'IMPLICIT';
                    }
                }
            }

            function onlySpecific() {
                $scope.routeOption = [specificRouteOption];
                $scope.ikeRouteConfiguration.ikeConfiguration.routeOption = 'SPECIFIC_RANGES';
            }

            $scope.$watch("ikeRouteConfiguration.onlySpecific", function(newVal, oldVal){
                if(newVal != oldVal) {
                    if(newVal == true) {
                       onlySpecific();
                    } else if(newVal == false) {
                        setOptions($scope.ikeRouteConfiguration.allRouteOptions);
                    }
                }
            });


            /**
             * open the plain text pop up according to the response
             * from the server
             */
            $scope.openShowInPlainText = function () {
                if($scope.ikeRouteConfiguration && $scope.ikeRouteConfiguration.ikeConfiguration && $scope.ikeRouteConfiguration.ikeConfiguration.routeOption){
                    store.fetch({
                        path: "/getIkeSiteRoutesAsPlainText",
                        queryParams: {
                            accountId: $state.params.accountId,
                            routeOption: $scope.ikeRouteConfiguration.ikeConfiguration.routeOption,
                            siteId: $scope.ikeRouteConfiguration.siteId
                        },
                        success: function(data) {
                            $scope.rangeText = data;
                            $scope.$root.openPopup('showInPlainText');
                        }
                    });
                }
            };
            init();
        }]
    };
});